import React, { useState, useEffect } from 'react';
import './Leaderboards.css';

const API_BASE_URL = 'https://links.everyonespinballclub.workers.dev';

const Leaderboards = () => {
  const [currentLeaderboard, setCurrentLeaderboard] = useState(null);
  const [pastLeaderboards, setPastLeaderboards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        setLoading(true);
        
        // Fetch current and past leaderboards
        const [currentResponse, pastResponse] = await Promise.all([
          fetch(`${API_BASE_URL}/api/current-leaderboard`),
          fetch(`${API_BASE_URL}/api/past-leaderboards`)
        ]);

        if (currentResponse.ok) {
          const currentData = await currentResponse.json();
          if (currentData.active && currentData.leaderboard) {
            setCurrentLeaderboard(currentData.leaderboard);
          }
        }

        if (pastResponse.ok) {
          const pastData = await pastResponse.json();
          setPastLeaderboards(pastData.groupedByYear || []);
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching leaderboard data:', err);
        setError('Failed to load leaderboard data');
        setLoading(false);
      }
    };

    fetchLeaderboardData();
  }, []);

  if (loading) {
    return (
      <div className="section leaderboards-container">
        <div className="loading-spinner">Loading leaderboards...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="section leaderboards-container">
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="section leaderboards-container">
      <h2 className="leaderboards-title">Leaderboards</h2>
      
      {/* Current Leaderboard */}
      {currentLeaderboard ? (
        <div className="current-leaderboard-section">
          <div className="current-leaderboard-card">
            <h3 className="current-label">Current Leaderboard</h3>
            <h4 className="current-month">{currentLeaderboard.label}</h4>
            {currentLeaderboard.description && (
              <p className="current-description">{currentLeaderboard.description}</p>
            )}
            <a 
              href={currentLeaderboard.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="current-leaderboard-link"
            >
              View Current Leaderboard →
            </a>
          </div>
        </div>
      ) : (
        <div className="no-leaderboard-message">
          <p>No current leaderboard available at this time.</p>
        </div>
      )}

      {/* Past Leaderboards Archive */}
      {pastLeaderboards.length > 0 && (
        <div className="past-leaderboards-section">
          <h3 className="archive-title">Past Leaderboards</h3>
          <div className="archive-grid">
            {pastLeaderboards.map((yearGroup) => (
              <div key={yearGroup.year} className="year-group">
                <h4 className="year-heading">{yearGroup.year}</h4>
                <ul className="leaderboard-list">
                  {yearGroup.items.map((leaderboard) => (
                    <li key={leaderboard.id}>
                      <a
                        href={leaderboard.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="past-leaderboard-link"
                      >
                        {leaderboard.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Leaderboards;
